const state = {
  type: null,
  data: null,
  config: null,
  callback: () => {},
  callbackCancel: () => {},
};

const getters = {};

const actions = {};

const mutations = {
  SHOW_DIALOG(state, payload) {
    state.type = payload.type;
    state.data = payload.data;
    state.config = payload.config
    state.callback = payload.callback;
    state.callbackCancel = payload.callbackCancel;
  },
  HIDE_DIALOG(state) {
    if (state.type && state.data) {
      state.type = null;
      state.data = null;
      state.config = null;
      state.callback = () => {};
      state.callbackCancel = () => {};
    }
  },
  DELETE_DIALOG(state, dialog) {
    Vue.delete(state.dialogs, dialog);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
